import { IAdmissionQueryProps } from '@/entities/Admission'
import { IAppointmentQueryProps, IScheduleQueryProps } from '@/entities/Appointment'
import { ICompanyQueryProps } from '@/entities/Company'
import { IDoctorQueryProps } from '@/entities/Doctor'
import { IUserQueryProps } from '@/entities/User'

export interface IFilterState {
  doctor: IDoctorQueryProps | null
  appointment: IAppointmentQueryProps | null
  user: IUserQueryProps | null
  admission: IAdmissionQueryProps | null
  schedule: IScheduleQueryProps | null
  company: ICompanyQueryProps | null
}

export const state = (): IFilterState => ({
  doctor: null,
  appointment: null,
  user: null,
  admission: null,
  schedule: null,
  company: null
})

export default state
